// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4771":"1b6d00a8","5122":"fde05586","6439":"eb41bba7"}[chunkId] + ".chunk.css";
};